import { useEffect, useState } from "react";
import { BRAND } from "../lib/constants";
import { BookNowButton } from "./Shared";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 flex items-center justify-between h-16 sm:h-20">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src={BRAND.logo}
            alt="The Neat Lab"
            className="h-10 w-10 sm:h-12 sm:w-12 rounded-full object-cover ring-1 ring-white/10 group-hover:ring-[#00E5FF]/60 transition-all"
          />
          <span className="hidden sm:block font-display text-lg font-semibold tracking-tight">
            The <span className="text-[#00E5FF]">Neat</span> Lab
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className="text-sm font-medium text-white/70 hover:text-white transition-colors font-body"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <BookNowButton
            variant="primary"
            className="hidden sm:inline-flex"
            testId="navbar-book-now"
          />
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-white"
            aria-label="menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-black/95 border-t border-white/10 px-5 py-6 space-y-4"
        >
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="block text-white/80 font-body text-base"
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              {item.label}
            </a>
          ))}
          <BookNowButton
            variant="primary"
            className="w-full justify-center"
            testId="mobile-book-now"
          />
        </div>
      )}
    </header>
  );
};
